import reducer from "./modal.reducer";

export { openModal, closeModal } from "./modal.actions";
export { getModalState } from "./modal.selectors";
export default reducer;
